import { useEffect, useState } from 'react'

export default function useAnimatedInputPlaceholderValues({
  placeholderValues,
  enableAnimation,
  inputValue,
  finalPlaceholderValue,
  stopAfterSeconds,
  maxValuesRounds,
  onPlaceholderExampleChange,
}) {
  const [animatedPlaceholder, setAnimatedPlaceholder] = useState('')

  useEffect(() => {
    let placeholderValueIndex = 0
    let placeholderCharIndex = 0
    let pauseRounds = 0
    let intervalId
    let showFinalPlaceholder = false
    let questionRounds = 0
    const startTime = Date.now()

    if (!enableAnimation) {
      setAnimatedPlaceholder(finalPlaceholderValue ?? placeholderValues[0])
      placeholderValueIndex = 0
      placeholderCharIndex = 0
      pauseRounds = 0
      intervalId = undefined
    } else if (inputValue?.length) {
      setAnimatedPlaceholder('')
      placeholderValueIndex = 0
      placeholderCharIndex = 0
      pauseRounds = 0
      intervalId = undefined
    } else {
      intervalId = setInterval(() => {
        const currentPlaceholder =
          (showFinalPlaceholder
            ? finalPlaceholderValue
            : placeholderValues[placeholderValueIndex]) ?? ''

        if (
          placeholderCharIndex === currentPlaceholder?.length &&
          pauseRounds > 60
        ) {
          if (
            Boolean(finalPlaceholderValue?.trim()) &&
            ((Boolean(stopAfterSeconds) &&
              stopAfterSeconds < (Date.now() - startTime) / 1000) ||
              (Boolean(maxValuesRounds) && questionRounds >= maxValuesRounds))
          ) {
            // reset only if we were not already showing the final placeholder
            if (!showFinalPlaceholder) {
              placeholderCharIndex = 0
            } else {
              clearInterval(intervalId)
            }

            showFinalPlaceholder = true
          } else {
            placeholderCharIndex = 0
            placeholderValueIndex =
              (placeholderValueIndex + 1) % placeholderValues.length

            if (placeholderValueIndex === placeholderValues.length - 1) {
              questionRounds++
            }

            pauseRounds = 0

            onPlaceholderExampleChange?.(placeholderValueIndex)
          }
        } else if (placeholderCharIndex === currentPlaceholder.length) {
          pauseRounds++
        } else {
          setAnimatedPlaceholder(
            currentPlaceholder.substring(0, placeholderCharIndex + 1)
          )
          placeholderCharIndex++
        }
      }, 30)
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId)
      }
    }
  }, [
    inputValue,
    enableAnimation,
    placeholderValues,
    finalPlaceholderValue,
    stopAfterSeconds,
    maxValuesRounds,
    onPlaceholderExampleChange,
  ])

  return animatedPlaceholder
}
